import { styled } from '@innowise-group/mui-kit';
import { NumberInput } from '@shared-mui-components';

// The name takes two thirds of the row and leaves the last third to the hiring managers
export const NameCell = styled.div`
  grid-column: span 2;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    grid-column: 1 / -1;
  }
`;

export const FullNumberInput = styled(NumberInput)`
  &.MuiTextField-root {
    width: 100% !important;
  }
`;

export const DatePickerContainer = styled.div`
  & .MuiTextField-root {
    width: 100% !important;
  }
  & .MuiOutlinedInput-root {
    padding-right: 2px;
  }
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-self: start;
  column-gap: 2rem;
  min-height: 2.75rem;
  margin-top: 10px;
`;
